import React, { useEffect, useState } from 'react';

/**
 * @param {{
 *   fullName: string,
 *   phone: string,
 *   email: string,
 *   errors: Record<string, string>,
 *   isSignedIn: boolean,
 *   contactPrefilled: boolean,
 *   onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
 * }} props
 */
const CheckoutContactSection = ({
  fullName,
  phone,
  email,
  errors,
  isSignedIn,
  contactPrefilled,
  onChange,
}) => {
  const hasContactErrors = Boolean(errors.fullName || errors.phone || errors.email);
  const canCompact =
    isSignedIn &&
    contactPrefilled &&
    fullName.trim() &&
    phone.trim() &&
    !hasContactErrors;
  const [expanded, setExpanded] = useState(!canCompact);

  useEffect(() => {
    if (hasContactErrors) setExpanded(true);
  }, [hasContactErrors]);

  useEffect(() => {
    if (canCompact) setExpanded(false);
  }, [canCompact]);

  const summaryParts = [fullName.trim(), phone.trim(), email.trim()].filter(Boolean);

  return (
    <section className="checkout-contact" aria-labelledby="checkout-contact-title">
      <div className="checkout-contact__head">
        <h3 id="checkout-contact-title" className="checkout-contact__title">
          Contact for this order
        </h3>
        {canCompact && !expanded ? (
          <button
            type="button"
            className="checkout-contact__edit"
            onClick={() => setExpanded(true)}
          >
            Edit
          </button>
        ) : null}
      </div>

      {canCompact && !expanded ? (
        <p className="checkout-contact__summary">{summaryParts.join(' · ')}</p>
      ) : (
        <>
          {isSignedIn && contactPrefilled ? (
            <p className="checkout-contact__hint">
              From your account — edit if this order is for someone else.
            </p>
          ) : null}

          <div className="cf-row">
            <div className="cf-group">
              <label htmlFor="checkout-fullName">Full name *</label>
              <input
                id="checkout-fullName"
                type="text"
                name="fullName"
                placeholder="Your full name"
                value={fullName}
                onChange={onChange}
                className={errors.fullName ? 'cf-input--error' : ''}
                autoComplete="name"
              />
              {errors.fullName ? <span className="cf-error">{errors.fullName}</span> : null}
            </div>
            <div className="cf-group">
              <label htmlFor="checkout-phone">Mobile number *</label>
              <input
                id="checkout-phone"
                type="tel"
                name="phone"
                inputMode="numeric"
                placeholder="10-digit mobile number"
                value={phone}
                onChange={onChange}
                maxLength={10}
                className={errors.phone ? 'cf-input--error' : ''}
                autoComplete="tel"
              />
              {errors.phone ? <span className="cf-error">{errors.phone}</span> : null}
            </div>
          </div>

          <div className="cf-group checkout-contact__email">
            <label htmlFor="checkout-email">Email (optional)</label>
            <input
              id="checkout-email"
              type="email"
              name="email"
              placeholder="For order confirmation"
              value={email}
              onChange={onChange}
              className={errors.email ? 'cf-input--error' : ''}
              autoComplete="email"
            />
            {errors.email ? <span className="cf-error">{errors.email}</span> : null}
          </div>

          {canCompact && expanded ? (
            <button
              type="button"
              className="checkout-contact__collapse"
              onClick={() => setExpanded(false)}
            >
              Done
            </button>
          ) : null}
        </>
      )}
    </section>
  );
};

export default CheckoutContactSection;
